<template>
    <div :class="{
            'ldc-select-show-option mb-2 px-2': true,
            'd-flex flex-wrap': labelPosition == 'left'
        }">
        <div :class="{
            'title-select py-2 mt-2': true,
            'mr-2': labelPosition == 'left'
        }" v-if="showPlaceholder">{{placeholder}}:</div>
        <slot/>
    </div>
</template>
<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: 'placeholder'
        },
        value: {
            default: '',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        showPlaceholder: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            data: '',
            model: '',
            options: [],
            labelPosition: 'left',
            change: null,
        }
    },
    watch: {
        value: {
            handler(val, oldVal){
                this.data = val;
            },
            deep: true,
        },
        data: {
            handler(val, oldVal){
                this.$emit('input', val);
                this.activeOption();
                
            },
            deep: true,
        },
        options: {
            handler(val){
                this.activeOption();
            },
            deep: true,
        },
    },
    created() {
        if(this.multiple){
            this.data = [];
            this.model = [];
        }
        let listeners = this.$listeners
        if(typeof(listeners.change) == 'function'){
            this.change = listeners.change;
        }
        this.data = this.value;
        this.activeOption();
    },
    updated() {
        this.activeOption();
    },
    mounted() {
        
    },
    methods: {
        activeOption(){
            let check = true;
            if(!this.$children) return;
            this.$children.map(item => {
                if(item.$options && item.$options._componentTag === 'ldc-option-show'){
                    if(!this.multiple){
                        if(this.data === item.$props.value){
                            item.$data.model = this.data;
                            this.model = item.$data.label;
                            item.$data.labelModel = this.model;
                            check = false;
                        }else{
                            item.$data.model = '';
                            item.$data.labelModel = '';
                        }
                    }else{
                        if(this.data.includes(item.$props.value)){
                            item.$data.model = item.$props.value;
                            if(!this.model.includes(item.$props.label)){
                                this.model.push(item.$props.label);
                            }
                            item.$data.labelModel = item.$props.label;
                            check = false;
                        }else{
                            item.$data.model = '';
                            item.$data.labelModel = '';
                        }
                    }
                }
            });
            if(check && !this.multiple){
                this.model = '';
            }
        },
    }
}
</script>